import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, LOCALE_ID } from '@angular/core';
import { MaterialModule } from './material.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import './rxjs-operators';
import { QuillModule } from 'ngx-quill'

import { SecurityModule } from './security/security.module';
import { HomeModule } from './home/home.module';
import { SubmissionModule } from './submission/submission.module';
import { AdministrationModule } from './administration/administration.module';
import { CustomerModule } from './customer/customer.module';
import { BusinessRuleModule } from './businessRule/business-rule.module';
import { VocabularyModule } from "./vocabulary/vocabulary.module";
import { MessagesModule } from "./messages/messages.module";
import { reducers, metaReducers } from './core/store/reducers';
import { AppComponent } from './core/components/app.component';
import { PageNotFoundComponent } from './core/components/page-not-found.component';
import { ClickActionDirective } from './common/directives/click-action.directive';
import { Services } from './core/services';
import { appRoutes } from './routes.config';
import { environment } from '../environments/environment';
import { LandingPageComponent } from './core/components/landing-page.component';
import { CoreModule } from './core/core.module';
import { ReportModule } from './report/report.module';
import { ExtractsModule } from './extracts/extracts.module';

import { ConfigurationModule } from './configuration/configuration.module';
import { MatNativeDateModule, MAT_DATE_LOCALE, MAT_DATE_FORMATS, DateAdapter } from '@angular/material';
import { MomentUtcDateAdapter } from './core/services/MomentUtcDateAdapter';
import { MAT_MOMENT_DATE_FORMATS } from '@angular/material-moment-adapter';
import { DynamicDataSetsModule } from './dynamicDataSets/dynamicDataSet.module';
import { ClientActionSignalRHubService } from './core/services/ClientActionSignalRHubService';
import { PillarModule } from './pillar/pillar.module';
import { DataWarehouseModule } from './datawarehouse/datawarehouse.module';
import { FramesModule } from './frames/frames.module';
import { LayoutModule } from './pillar/layout/layout.module';
import { PortalModule } from './portal/portal.module';

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    MaterialModule,
    FlexLayoutModule,
    StoreModule.forRoot(reducers, { metaReducers }),
    EffectsModule.forRoot([]),
    HttpClientModule,
    RouterModule.forRoot(
      appRoutes,
      { enableTracing: !environment.production } // <-- debugging purposes only
    ),
    CoreModule,
    SecurityModule.forRoot(),
    PortalModule,
    HomeModule,
    AdministrationModule,
    ConfigurationModule,
    SubmissionModule,
    VocabularyModule,
    MessagesModule,
    CustomerModule,
    BusinessRuleModule,
    ReportModule,
    MatNativeDateModule,
    DynamicDataSetsModule,
    PillarModule,
    QuillModule.forRoot(),
    DataWarehouseModule,
    ExtractsModule,
    FramesModule,
    LayoutModule
  ],
  providers: [Services,
    { provide: LOCALE_ID, useValue: 'en-US' },
    { provide: MAT_DATE_LOCALE, useValue: 'en-US' },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
    { provide: DateAdapter, useClass: MomentUtcDateAdapter }
  ],
  bootstrap: [AppComponent],
  declarations: [AppComponent, ClickActionDirective, PageNotFoundComponent, LandingPageComponent]
})
export class AppModule {
  constructor(private clientActionSignalRHubService: ClientActionSignalRHubService) {
    clientActionSignalRHubService.initialize();
  }
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts